/**
 * Browser Notification Handler Component
 * Manages real-time notification listening and displays browser notifications
 * This component should be mounted at the app level to work globally
 */

import { ReactNode } from 'react';
import { useNotificationPolling } from '../hooks/useNotificationPolling';

interface BrowserNotificationHandlerProps {
  children: ReactNode;
}

export function BrowserNotificationHandler({ children }: BrowserNotificationHandlerProps) {
  // Start listening for notifications
  const { isListening, lastNotification } = useNotificationPolling();

  // Log status for debugging
  if (isListening && lastNotification) {
    console.log('📡 Notification listener active. Last notification:', lastNotification.toLocaleTimeString());
  }

  // This component just wraps children and runs the notification listener hook
  // It doesn't render any UI itself
  return <>{children}</>;
}

export default BrowserNotificationHandler;

